import React from "react";
import ProductModalWrapper from "../ProductModalWrapper";

import styles from "./MainApp.organisms.Product.Modals.WrongContentModal.module.scss";
import i18n from "i18n";
export class WrongContentModal extends React.Component {
  render() {
    const {  open, invalidFilesQuantity, totalQuantity,
      handleClose, handleGoBack, handleDownloadTemplate,
      handleDownloadErrors, handleClick } = this.props;

    const content = (<div className={styles["wrong-content-modal-wrapper"]}>
        <div className={styles["wrong-content-modal-title"]}>{i18n.t("incorrect.content")}</div>
        <div className={styles["wrong-content-modal-text"]}>{i18n.t("invalid.products.found", {invalidFilesQuantity: invalidFilesQuantity, totalQuantity: totalQuantity})}</div>
        <div className={styles["wrong-content-modal-download"]}>
        <i className={`${styles["wrong-content-modal-icon"]} icon-iconos_descargar`}></i>
            <p onClick={handleDownloadErrors} data-automation-id="download-summary">{i18n.t("download.summary")}</p>
        </div>
    </div>)
    return (
      <div className={styles["wrong-content-modal-container"]}>
          <ProductModalWrapper open={open} innerContent={content}
            buttonLegend={"SUBIR OTRO ARCHIVO"} handleGoBack={handleGoBack}
            handleDownloadTemplate={handleDownloadTemplate}
            handleClose={handleClose} handleClick={handleClick}
            ></ProductModalWrapper>
      </div>
    );
  }
}

WrongContentModal.propTypes = {
};

export default WrongContentModal;
